<div class="modal-backdrop fade d-block d-lg-none" *ngIf="isVisible" [class.show]="isVisible"></div>
<div class="modal fade d-block d-lg-none" *ngIf="isVisible" 
 >
  <div class="modal-dialog signin-modal rating-modal">
   
    <div class="modal-content">
        <button type="button" class="btn-close-1 close pull-right d-flex align-items-center jusity-content-center popup-close-btn"
        aria-label="Close" (click)="closeModal()">
        <i class="sprite-img-header-footer black-cross-circle"></i>
      </button>
        <img class="img-fluid promotion-image" src="./assets/images/app_rating_icon.svg" alt="app promotion image">
      <h5>We’re thrilled to offer free tender viewing and document downloads.</h5>
      <p>Help us keep it that way by leaving a review on the Play Store. Your feedback is invaluable!</p>
      <!-- <a href="">
        <img class="img-fluid" src="./assets/images/google-play-badge.svg" alt="google play redirection button">
      </a> -->
      <button  type="button" class="btn red-btn w-100" > RATE US ON PLAYSTORE </button>
    </div>
  </div>
</div>